import _funzioni from '../../msp/funzioni.js';
import rangeZone from '@cached/zona_range.json';
import { formatIntervallo } from '@src/js/lib/configAndatura.js';
// Il testo di un'andatura per la descrizione automatica è in src/shared/msp/descrizioneAutomatica.js.
const azr = {

    zonaRangeDescrizione: function (andatura, sep = " ") {
        // Il valore arriva anche come stringa dal select ("0" è truthy): decide show_in_description.
        let zonaRange = rangeZone.find(el=>el.id == andatura.andatura_zona_range);
        if (!zonaRange || !zonaRange.show_in_description) return "";
        return sep+zonaRange.nome;
    },

    makeZonaForRange: function (test, id) {
        let zr;
        let zona = test.zone.find((zona)=>+zona.id===+id);
        if (zona) {
            zr = {
                zona:zona,
                um_id:test.um_id,
                tipo_id: test.um_tipo_id,
                tipo_descrizione: test.um_tipo_descrizione,
                tipo_codice: test.um_tipo_codice,
                um_descrizione:test.um_descrizione
            };
        } else {
            zr = null;
        }
        return zr;
    },
    hasCustomRange: function (andatura) {
        const hasCustomRange = (andatura.andatura_zona_range_da || andatura.andatura_zona_range_a);
        return hasCustomRange;
    },

    // Zona immediatamente precedente (direction -1) o successiva (+1) nella progressione
    // della scala, per la sfumatura fra zone in getZonaColor. zoneList è già filtrata per
    // sport dal chiamante (MspGraficoAndature/MspGraficoAndatureSemplice). Solo le zone
    // mostrate nei grafici (show_in_grafici) partecipano alla progressione: Z0/REC sono
    // pseudo-zone di servizio, non punti reali della scala. null se zona è già all'estremo.
    getZonaAdiacente: function (zoneList, zona, direction) {
        const scala = zoneList
            .filter(el => +el.show_in_grafici === 1)
            .sort((a, b) => +a.posizione - +b.posizione);
        const index = scala.findIndex(el => +el.id === +zona.id);
        if (index === -1) return null;
        return scala[index + direction] || null;
    },

    // Colore della barra sfumato verso la zona adiacente in base a dove cade il range
    // dentro la zona corrente (rangePercent: v. MspGraficoAndature.buildItem lato JS e
    // getGraficoSemplice lato PHP, entrambi ne calcolano un equivalente): verso l'estremo
    // basso si sfuma verso il colore della zona precedente nella scala, verso l'estremo
    // alto verso quello della zona successiva — il colore resta così continuo anche
    // attraversando il confine fra due zone, invece di un mix fisso uguale per tutte le
    // zone. Le due zone di confine della scala (nessuna zona precedente/successiva, v.
    // getZonaAdiacente) sfumano verso bianco/nero, coerente col fatto che sono i colori
    // "limite" della progressione. rangePercent null/undefined (nessun range custom
    // sull'andatura) restituisce il colore piatto della zona, senza mix.
    getZonaColor: function (zoneList, zona, rangePercent) {
        const color = zona.colore;
        if (rangePercent == null) return color;
        const MAX_MIX = 40; // % massimo di colore adiacente mescolato agli estremi del range
        if (rangePercent < 50) {
            const pct = Math.round((50 - rangePercent) / 50 * MAX_MIX);
            if (pct <= 0) return color;
            const prevColor = (azr.getZonaAdiacente(zoneList, zona, -1) || {}).colore || '#fff';
            return `color-mix(in oklab, ${prevColor} ${pct}%, ${color})`;
        }
        if (rangePercent > 50) {
            const pct = Math.round((rangePercent - 50) / 50 * MAX_MIX);
            if (pct <= 0) return color;
            const nextColor = (azr.getZonaAdiacente(zoneList, zona, 1) || {}).colore || '#000';
            return `color-mix(in oklab, ${nextColor} ${pct}%, ${color})`;
        }
        return color;
    },

    formatDescrizioneZona: function (zona_obj, andatura) {
        let zona = zona_obj.zona;
        let result;
        let params = [zona_obj.um_id, zona_obj.um_descrizione];
        let value_da;
        let value_a;
        if (azr.hasCustomRange(andatura)) {
            let norm = zona.a - zona.da;
            value_da = zona.da + norm * andatura.andatura_zona_range_da/100;
            value_a = zona.da + norm * andatura.andatura_zona_range_a/100;
        } else {
            value_da = zona.da;
            value_a = zona.a;
        }
        let valueDaString = _funzioni.formatRisultatoByUmId(value_da, ...params,false);
        let valueAString = _funzioni.formatRisultatoByUmId(value_a, ...params, true);
        result = formatIntervallo(valueDaString, valueAString);
        return result;
    },
}
export default azr;

export const methods = {
    zonaRangeDescrizione: azr.zonaRangeDescrizione,
    makeZonaForRange: azr.makeZonaForRange,
    hasCustomRange: azr.hasCustomRange,
    formatDescrizioneZona: azr.formatDescrizioneZona,
    getZonaAdiacente: azr.getZonaAdiacente,
    getZonaColor: azr.getZonaColor,
}
